import Acronyms from "../../acronyms";
import { BaSeParagraph, BaSeSmall2 } from "@base/react";
import {eventTag} from "../../../services/utils";
import "./index.scss";

const CardInputCompany = ({ data, callBack, event = {} }) => {
  return (
    <div className={"card-input-company " + (data.isActive ? "active" : "")}>
      <div className="wrapper" onClick={() => {
        callBack(data.cnpj)
        eventTag(event?.name, event?.category, "submit", "Seleção de empresa")
      }}>
        <div
          className={`company__radio ${data.isActive ? "selected" : ""}`}
          key={data.cnpj}
        >
          <div className="company__radio__data">
            <Acronyms nameUser={data.name} />
            <div className="company__radio__data__text">
              <BaSeParagraph className="company-name" isBold color="#2E5DE6">
                {data.name}
              </BaSeParagraph>
              <BaSeSmall2 color="#243342">
                CNPJ:{" "}
                {data.cnpj.replace(
                  /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
                  "$1.$2.$3/$4-$5"
                )}
              </BaSeSmall2>
              {/*<BaSeSmall2 color="#243342">Criada em: XX/XX/XXXX</BaSeSmall2>*/}
            </div>
          </div>
          <div className="company__radio__checkbox">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="21"
              viewBox="0 0 20 21"
              fill="currentColor"
            >
              <path
                d="M15.5917 6.52384C15.4353 6.36608 15.2223 6.27734 15.0001 6.27734C14.7779 6.27734 14.5649 6.36608 14.4084 6.52384L8.20006 12.7405L5.59173 10.1238C5.3729 9.91246 5.05793 9.83388 4.76545 9.91769C4.47298 10.0015 4.24744 10.235 4.17379 10.5302C4.10014 10.8254 4.18957 11.1375 4.40839 11.3488L7.60839 14.5488C7.76486 14.7066 7.97786 14.7953 8.20006 14.7953C8.42226 14.7953 8.63525 14.7066 8.79173 14.5488L15.5917 7.74884C15.7627 7.59108 15.86 7.36901 15.86 7.13634C15.86 6.90368 15.7627 6.68161 15.5917 6.52384Z"
                fill="currentColor"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardInputCompany;
